export default __webpack_public_path__ + "static/media/SourceSansPro-Bold.12e6acd2.ttf";